<template>
  <main>
    <div class="add-note">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.feuillePresence") }}</h3>
            </template>
            <template v-slot:right-element>
              <router-link :to="{name: 'ShowRegisterPresenc'}" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </router-link>
            </template>
          </TopTemplate>
        </div>
      </div>

      <div v-if="msgFapp" class="alert alert-danger" role="alert">L'heure et la date de la feuille d'appel existent déjà.</div>
      <div v-if="is_created" class="alert alert-success" role="alert">
        {{ $t("info.addRegister") }}
      </div>
      <div v-if="is_brouillon" class="alert alert-success" role="alert">
        {{ $t("info.registerBrouillon") }}
      </div>

      <div v-if="isSelected" class="row container-select container-filter">
        <div class="col-sm-8">
          <div class="title-filter-open">
            <div class="class-name">
              <span class="info-text">{{ $t("register.filter.title") }}</span>
              <span>{{ classNameSelcted }} - {{ courseNameSelcted }} </span>
            </div>
            <div class="calendrier">
              <img src="../../../images/calendrier.svg" alt="calendrier" />
              <span class="color-span">{{ formatDateString(dateSelected) }} </span>
            </div>
            <div class="timer">
              <img src="../../../images/timer.svg" alt="timer" />
              <span class="color-span">{{ startTime }}-{{ endTime }}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="reset_student reset_note" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
      </div>
      <div v-if="!isSelected" class="row container-select container-filter content-crit">
        <h3 class="title-filter">{{ $t("register.filter.title") }}</h3>
        <span class="title-filter-sub">{{ $t("register.msgAdd") }}</span>
        <div class="supparation"></div>
        <div class="col-sm-2 col-12 select-wrapper">
          <v-select
            v-model="register.selectedLevel"
            class="form-control"
            :searchable="true"
            :class="v$.register.selectedLevel.$error ? 'is-invalid' : ''"
            :options="levels"
            label="name"
            placeholder="Niveau*"
            :reduce="(option) => option"
            @update:modelValue="ChangeLevel($event)"
          >
            <template #no-options="{loading}">
              <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">{{ $t("common.emptysearshLevels") }}</div>
              <div v-else class="card mt-2 text-center d-block pt-2 pb-2">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </template>
          </v-select>
          <span v-if="v$.register.selectedLevel.$error" class="invalid-feedback">{{ v$.register.course_id.$errors[0].$message }}</span>
        </div>
        <div class="col-sm-2 col-12 select-wrapper">
          <v-select
            v-model="register.class_id"
            :options="classes"
            label="name"
            placeholder="Classe*"
            :searchable="true"
            :reduce="(option) => option"
            class="form-control"
            :disabled="disabledClass"
            :class="v$.register.class_id.$error ? 'is-invalid' : ''"
            @update:modelValue="ChangeClasses($event)"
          >
            <template #no-options="{loading}">
              <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">{{ $t("common.emptysearchClasse") }}</div>
              <div v-else class="card mt-2 text-center d-block pt-2 pb-2">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </template>
          </v-select>
          <span v-if="v$.register.class_id.$error" class="invalid-feedback">{{ v$.register.course_id.$errors[0].$message }}</span>
        </div>
        <div class="col-sm-2 col-12 select-wrapper">
          <v-select
            v-model="register.course_id"
            :options="courses"
            label="name"
            :searchable="true"
            placeholder="Matière*"
            :reduce="(option) => option.id"
            class="form-control"
            :disabled="!register.class_id"
            :class="v$.register.course_id.$error ? 'is-invalid' : ''"
          >
            <template #no-options="{loading}">
              <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">{{ $t("common.emptysearchCourse") }}</div>
              <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </template>
          </v-select>
          <span v-if="v$.register.course_id.$error" class="invalid-feedback">{{ v$.register.course_id.$errors[0].$message }}</span>
        </div>
        <div class="col-sm-2 col-12 select-wrapper datepicker-custom">
          <Datepicker
            v-model="register.date"
            :enable-time-picker="false"
            locale="fr"
            autoApply
            text-input
            placeholder="Date*"
            :max-date="new Date()"
            :format="format_date_v1"
            class="form-control"
            :class="v$.register.date.$error ? 'is-invalid' : ''"
            @update:modelValue="formatByDate"
          />
          <span v-if="v$.register.date.$error" class="invalid-feedback">{{ v$.register.date.$errors[0].$message }}</span>
        </div>
        <div class="col-sm-2 col-12 select-wrapper">
          <v-select
            v-model="register.start_time"
            :options="timeOptions"
            :searchable="true"
            @update:modelValue="updateEndTimeOptions"
            placeholder="Début*"
            class="form-control"
            :class="v$.register.start_time.$error ? 'is-invalid' : ''"
          >
            <template #no-options="{loading}">
              <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">{{ $t("common.emptyHeure") }}</div>
              <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </template>
          </v-select>
          <span v-if="v$.register.start_time.$error" class="invalid-feedback">{{ v$.register.start_time.$errors[0].$message }}</span>
        </div>
        <div class="col-sm-2 col-12 select-wrapper stylebtndebut">
          <v-select
            v-model="register.end_time"
            :options="endTimeOptions"
            :searchable="true"
            placeholder="Fin*"
            class="form-control"
            :class="v$.register.end_time.$error ? 'is-invalid' : ''"
          >
            <template #no-options="{loading}">
              <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">{{ $t("common.emptyHeure") }}</div>
              <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </template>
          </v-select>
          <span v-if="v$.register.end_time.$error" class="invalid-feedback">{{ v$.register.end_time.$errors[0].$message }}</span>
        </div>
        <div class="col-sm-12 col-12 select-wrapper">
          <a @click="valideCriter()" class="btn btn-primary button btn-confirm-filter"> {{ $t("info.criteresRegister") }}</a>
        </div>
      </div>
      <div class="col-md-12">
        <div v-if="!loading && notExistStudents" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshNote") }}</p>
          </div>
        </div>
      </div>
      <div v-if="isSelected" class="empty-message">
        <div class="col-md-12">
          <div v-if="loading" class="mt-4 text-center d-block pt-4 pb-4">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && getStudentsList.length > 0 && isSelected && !msgFapp">
        <div class="table message-list custom-table">
          <div class="content-note">
            <div class="row container-select container-filter container-note">
              <div v-if="loading" class="mt-4 text-center d-block pt-4 pb-4">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div class="col-sm-4">
                <h3 class="title-filter title-tab-note">
                  <span>{{ $t("register.sousTitle") }}</span>
                </h3>
              </div>
              <div v-if="isSelected && getStudentsList.length > 0" class="col-sm-8 buttons">
                <div class="button-right d-flex justify-content-end btn-action-note">
                  <button type="submit" class="btn btn-outline-primary button btn-cancel" @click.prevent="cancelBtn()" :disabled="isSubmitted">{{ $t("button.annuler") }}</button>
                  <button type="submit" class="btn button btn-primary" @click="onSubmitCreateDevoir(1)" :disabled="isSubmitted">{{ $t("button.publier") }}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table__note table">
                  <table>
                    <thead>
                      <tr>
                        <th class="col-md-4 name-padding">{{ $t("register.tab.name") }}</th>
                        <th class="col-md-2 center-th">
                          <p>{{ $t("register.tab.absent") }}</p>
                        </th>
                        <th class="col-md-2 center-th">
                          <p>{{ $t("register.tab.retard") }}</p>
                        </th>
                        <th class="col-md-2 center-th">
                          <p>{{ $t("register.tab.exclu") }}</p>
                        </th>
                        <th class="col-md-4 right-padding">{{ $t("register.tab.remarque") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(student, index) in getStudentsList" :key="index">
                        <td class="col-md-4 name-std">
                          <span v-if="[ABSENT, EXCLU].includes(student.status)" class="eleve-absent"></span>
                          {{ student.first_name }} {{ student.last_name }}
                        </td>
                        <td class="col-md-2" :class="{'absent-class': student.status === ABSENT}">
                          <label class="container-checkbox">
                            <input
                              v-model="student.status"
                              type="radio"
                              :name="'status' + index"
                              :checked="student.status === ABSENT"
                              :value="ABSENT"
                              @click="setPresentValue($event, student, ABSENT)"
                            />
                            <span class="checkmark" />
                          </label>
                        </td>

                        <td class="col-md-2">
                          <label class="container-checkbox">
                            <input
                              v-model="student.status"
                              type="radio"
                              :name="'status' + index"
                              :checked="student.status === DELAY"
                              :value="DELAY"
                              @click="setPresentValue($event, student, DELAY)"
                            />
                            <span class="checkmark" />
                          </label>
                        </td>

                        <td class="col-md-2" :class="{'absent-class': student.status === EXCLU}">
                          <label class="container-checkbox">
                            <input
                              v-model="student.status"
                              type="radio"
                              :name="'status' + index"
                              :checked="student.status === EXCLU"
                              :value="EXCLU"
                              @click="setPresentValue($event, student, EXCLU)"
                            />
                            <span class="checkmark" />
                          </label>
                        </td>
                        <td class="col-md-4 text-center cment-inp right-padding">
                          <input v-model="student.remark" placeholder="Ajouter votre remarque" type="text" class="form-control" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isSelected && getStudentsList.length > 0 && !msgFapp" class="col-12 buttons btn-action btn-action-note">
        <div class="button-right d-flex justify-content-end mb-4">
          <button type="submit" class="btn btn-outline-primary button btn-cancel" @click.prevent="cancelBtn()" :disabled="isSubmitted">{{ $t("button.annuler") }}</button>
          <button type="submit" class="btn button btn-primary" @click="onSubmitCreateDevoir(1)" :disabled="isSubmitted">{{ $t("button.publier") }}</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import RegisterClass from "../../services/registerClass.service";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import vSelect from "vue-select";
import useValidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";

export default {
  name: "AddRegister",
  components: {
    TopTemplate,
    "v-select": vSelect,
    Datepicker,
  },
  data() {
    return {
      courses: [],
      classes: [],
      levels: [],
      is_created: false,
      is_brouillon: false,
      hasAbsentClass: false,
      ABSENT: 1,
      DELAY: 2,
      PRESENT: 3,
      EXCLU: 4,
      levelSelected: "",
      getStudentsList: [],
      due_date: null,
      isAbsent: true,
      msgFapp: false,
      params: {
        class_type_id: [],
        class_ids: [],
        class_school_id: [],
        class: null,
      },
      register: {
        selectedLevel: null,
        class_id: null,
        course_id: null,
        selectedType: "une_classe",
        selectedStudent_ids: [],
        start_time: "",
        end_time: "",
        date: "",
        students: [
          {
            id: null,
            remark: "",
          },
        ],
      },
      timeOptions: [
        {value: "08:00", label: "08:00"},
        {value: "09:00", label: "09:00"},
        {value: "10:00", label: "10:00"},
        {value: "11:00", label: "11:00"},
        {value: "12:00", label: "12:00"},
        {value: "13:00", label: "13:00"},
        {value: "14:00", label: "14:00"},
        {value: "15:00", label: "15:00"},
        {value: "16:00", label: "16:00"},
        {value: "17:00", label: "17:00"},
      ],
      endTimeOptions: [],
      loading: false,
      v$: useValidate(),
      isSelected: false,
      isDraft: null,
      isSubmitted: false,
      classNameSelcted: null,
      dateSelected: null,
      startTime: null,
      endTime: null,
      courseNameSelcted: null,
      notExistStudents: false,
    };
  },
  validations() {
    return {
      register: {
        date: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        start_time: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        end_time: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        selectedLevel: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        selectedType: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        class_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        course_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },

  computed: {
    disabledClass() {
      return (!this.register.selectedLevel && this.register.selectedType == "une_classe") || (!this.register.selectedLevel && this.register.selectedType == null);
    },
  },

  mounted() {
    this.FilterClass();
  },
  methods: {
    setPresentValue(event, student, value) {
      if (event.target.checked && student.status == value) {
        event.target.checked == !event.target.checked;
        student.status = this.PRESENT;
      }
    },
    formatDateString(dateString) {
      const formattedDate = moment.utc(dateString).format("DD-MM-YYYY");
      return formattedDate;
    },
    updateEndTimeOptions() {
      if (!this.register.start_time) {
        this.register.end_time = [];
        this.endTimeOptions = [];
        return;
      }
      const startValue = this.register.start_time ? parseInt(this.register.start_time.value.split(":")[0]) : null;
      this.endTimeOptions = this.timeOptions.filter((option) => {
        const endValue = parseInt(option.value.split(":")[0]);
        return startValue === null || endValue > startValue;
      });
    },

    formatByDate: _.debounce(function () {
      if (this.register.date != null) {
        this.register.date = this.dateTime(this.register.date);
      }
    }, 200),

    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },

    FilterClass() {
      this.loading = true;
      RegisterClass.getFilter({
        params: {
          type_id: this.params.class_type_id,
          class_type_id: this.params.class_ids,
          class_school_id: this.params.class_school_id,
        },
      })
        .then((response) => {
          this.classes = _.orderBy(response.data.classes, "name");
          this.levels = response.data.types;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).utc().format("DD-MM-YYYY");
      }
    },

    ChangeLevel(e) {
      this.is_created = false;
      this.is_brouillon = false;
      this.msgFapp = false;
      if (e != null) {
        this.register.class_id = null;
        this.courses = [];
        this.register.selectedLevel = e;
        if (e) this.classes = _.orderBy(e.classe, "name");
      } else {
        this.params.class_type_id = [];
        this.register.course_id = null;
        this.register.class_id = null;
        this.register.selectedLevel = null;
      }
    },

    ChangeClasses(e) {
      this.is_created = false;
      this.is_brouillon = false;
      this.msgFapp = false;

      this.register.course_id = null;
      if (e) {
        this.courses = [];
        this.register.selectedStudent_ids = [];
        this.params.class_ids = e;
        this.params.class_school_id = e;
        this.params.class = e.id;

        this.courses = _.orderBy(e.courses, "name");
        if (e.students) {
          this.students = _.orderBy(e.students, "first_name");
          this.students.map(function (item) {
            return (item.item_data = item.first_name + " " + item.last_name);
          });
        }
      } else {
        this.params.class_ids = null;
        this.register.selectedStudent_ids = [];
      }
    },

    getStudents() {
      this.loading = false;
      this.selected = [];
      RegisterClass.getStudents({
        params: {
          class: this.params.class,
          start_time: this.startTime,
          date: this.dateSelected,
        },
      })
        .then((response) => {
          this.getStudentsList = response.data.data;
          if (this.getStudentsList.length == 0) {
            this.notExistStudents = true;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.msgFapp = true;
          }
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetFilter() {
      this.v$.$reset();
      this.msgFapp = false;
      this.isSelected = false;
      this.classNameSelcted = null;
      this.notExistStudents = false;
      (this.dateSelected = null), (this.startTime = null), (this.endTime = null), (this.courseNameSelcted = null);
      (this.register.selectedLevel = null),
        (this.register.class_id = null),
        (this.register.course_id = null),
        (this.register.start_time = null),
        (this.register.end_time = null),
        (this.register.date = null);
    },

    onSubmitCreateDevoir(type) {
      this.isSubmitted = true;
      const studentsData = this.getStudentsList.map((student) => {
        return {
          id: student.id,
          remark: student.remark,
          status: student.status ?? this.PRESENT,
        };
      });
      const formData = {
        _method: "POST",
        class_school_id: this.register.class_id.id,
        course_id: this.register.course_id,
        date: this.register.date,
        students: studentsData,
        status: type,
        start_time: this.register.start_time.value,
        end_time: this.register.end_time.value,
      };

      RegisterClass.create(formData)
        .then(() => {
          this.isSubmitted = false;
          if (type === 1) {
            this.is_created = true;
          }
          if (type === 0) {
            this.is_brouillon = true;
          }

          this.resetFilter();
        })
        .then(() => {})
        .catch((error) => {
          this.is_created = false;
          this.is_brouillon = false;
          this.msgFapp = false;
          this.errorMessage = error.response.data.error;
        })
        .finally(() => {
          this.isConfirmed = false;
          this.loading = false;
        });
    },

    valideCriter() {
      this.is_created = false;
      this.is_brouillon = false;
      this.msgFapp = false;
      this.v$.$validate();
      if (!this.v$.$error) {
        this.loading = true;
        this.classNameSelcted = this.classes.find((item) => item.id === this.params.class_ids.id).name;
        this.courseNameSelcted = this.courses.find((item) => item.id === this.register.course_id).name;
        this.dateSelected = this.register.date;
        this.startTime = this.register.start_time.label;
        this.endTime = this.register.end_time.label;
        this.isSelected = true;
        this.getStudents();
      }
    },
    cancelBtn() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmCancel"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.resetFilter();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.vs--single .vs__selected {
  font-size: 12px;
  line-height: 14px;
}
.datepicker-input::placeholder {
  color: #999 !important;
  font-style: italic !important;
}

.title-filter {
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    color: black;
  }
}
.title-filter-open {
  display: flex;
  img {
    padding-right: 5px;
  }
  .class-name {
    .info-text {
      color: #377879;
    }
  }
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    color: black;
    padding-right: 10px;
  }
  .color-span {
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: left;
    color: #377879;
  }
}

.btn-cancel {
  background: transparent;
}
.title-filter {
  font-size: 14px;
  font-weight: 700;
  color: #3d3d3d;
}
.title-filter {
  span {
    color: #377879;
  }
}
.title-filter-sub {
  font-size: 11px;
  font-weight: 500;
  color: #3d3d3d;
  font-style: italic;
  margin-left: 10px;
}

.btn-confirm-filter {
  margin-left: auto;
  margin-top: 15px;
  font-size: 14px;
  font-weight: 600;
  background-color: #377879;
  border-color: #377879;
}
.btn-confirm-filter:hover {
  color: #377879 !important;
  border-color: #377879;
}
.table__note.table > :not(caption) > * > * {
  border: none;
}
.table__note.table table td {
  border: none;
}
.table__note {
  padding: 4px;
  table {
    border-radius: unset;
    background: unset;
    padding: 23px;
    thead {
      tr {
        border-top: 3px solid #e0e7ed !important;
        border-bottom: 3px solid #e0e7ed !important;
        background: #f1fafa !important;
        th {
          color: #377879;
          font-size: 13px;
          font-weight: 700;
        }
      }
    }
    tbody {
      td {
        padding: 8px;
      }
      td.name-std {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        padding-left: 30px;
      }
    }
  }
}
.content-note {
  background: #fff;
  border-radius: 5px;
}
.title-tab-note {
  margin-bottom: 0;
  margin-top: 12px;
}
.btn-action {
  margin-top: 20px;
}
.cment-inp {
  input {
    padding-left: 20px;
    font-size: 12px;
    color: #333333;
  }
  input::placeholder {
    font-style: italic;
    color: #a098ae;
  }
}
.container-note {
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 11px;
  padding-right: 0;
  padding-left: 0;
}
.btn-action-note {
  .button {
    margin-left: 10px;
  }
  .button.btn-primary {
    background: #377879;
    border: 1px solid #377879;
  }
  .button.btn-primary:hover {
    background: #fff;

    color: #377879 !important;
  }
  .btn-cancel {
    color: #377879 !important;
    border: 1px solid #377879;
  }
  .btn-cancel:hover {
    background: #377879;
    color: #fff !important;
  }
}
.reset_note {
  color: #34b9bb;
  font-size: 14px;
  font-weight: 600;
}
.supparation {
  width: 100%;
  margin: 16px 0 19px 0;
  border-top: 1px solid #e0e7ed;
}
.container-filter {
  padding-left: 0;
}
.table .container-checkbox .checkmark:after {
  left: 4px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #34b9bb;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.table .container-checkbox input:checked ~ .checkmark {
  background-color: white;
}

.absent-class .container-checkbox .checkmark:after {
  left: 4px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #f35b19;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.container-checkbox input:checked ~ .checkmark {
  background-color: white;
  border-color: #e1e1e1;
}
.eleve-absent {
  width: 12px;
  height: 12px;
  background-color: #f35b19;
  display: inline-flex;
  border-radius: 50%;
  margin-left: -21px;
  margin-right: 10px;
}
.name-padding {
  padding-left: 30px;
}
.right-padding {
  padding-right: 30px;
}
.stylebtndebut .vs__dropdown-menu li:last-child {
  display: none;
}
.center-th p {
  margin-bottom: 0;
  margin-left: -20px;
}
</style>
